import type { ConsentState } from './types';

const COOKIE_NAME = '_uconsent';
const COOKIE_MAX_AGE = 31536000; // 365 days

export function readConsentCookie(): ConsentState | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${COOKIE_NAME}=`));
  if (!match) return null;
  try {
    const raw = decodeURIComponent(match.slice(COOKIE_NAME.length + 1));
    return JSON.parse(raw) as ConsentState;
  } catch {
    return null;
  }
}

export function writeConsentCookie(state: ConsentState): void {
  if (typeof document === 'undefined') return;
  const encoded = encodeURIComponent(JSON.stringify(state));
  document.cookie = [
    `${COOKIE_NAME}=${encoded}`,
    `max-age=${COOKIE_MAX_AGE}`,
    'path=/',
    'SameSite=Strict',
    'Secure',
  ].join('; ');
}
